import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'projects/access-control/src/environments/environment';
import { Resource } from '../../Domain/Entities/resource-interface';

@Injectable({
  providedIn: 'root'
})
export class SearchResourcesService {

	constructor(private api: ApiService, private http: HttpClient) {}
  getResource(pk: string, sk:string): Observable<Resource> {
		return this.http.get<any>(`${environment.apiUrl}/resources/${pk}/${sk}`);
	}
}
